import { render, staticRenderFns } from "./viewSummaryDetils.vue?vue&type=template&id=96ae9a5c&scoped=true&"
import script from "./viewSummaryDetils.vue?vue&type=script&lang=js&"
export * from "./viewSummaryDetils.vue?vue&type=script&lang=js&"
import style0 from "./viewSummaryDetils.vue?vue&type=style&index=0&id=96ae9a5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ae9a5c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96ae9a5c')) {
      api.createRecord('96ae9a5c', component.options)
    } else {
      api.reload('96ae9a5c', component.options)
    }
    module.hot.accept("./viewSummaryDetils.vue?vue&type=template&id=96ae9a5c&scoped=true&", function () {
      api.rerender('96ae9a5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/reconciliationDetails/components/viewSummaryDetils.vue"
export default component.exports